import React, { Fragment, useState, useContext, useReducer } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";

const apiUrl = "/wp-json/salesforce/v1/funds";

import { EligibilityContext } from "../../../contexts/EligibilityContext";
import {
  nameRegex,
  phoneRegex,
  dateRegex,
  zipRegex,
  emailRegex,
} from "../../../helpers/regex";
const Email = () => {
  const context = useContext(EligibilityContext);
  const { register, handleSubmit, errors } = useForm();

  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [supportServiceIds, dispatchSupportServiceIds] = useReducer(
    (supportServiceIds, { type, value }) => {
      switch (type) {
        case "add":
          return [...supportServiceIds, value];
        case "remove":
          return supportServiceIds.filter((id) => id !== value);
        case "clear":
          return [];
        default:
          return supportServiceIds;
      }
    },
    [] // defaults to an empty array
  );

  const subscribe = (data) => {
    if (!data) {
      return false;
    }

    setSubmitting(true);

    const requestBody = {
      ProgramId: supportServiceIds.join(";"),
      ContactId: "",
      FirstName: data.firstName,
      MiddleName: data.middleName,
      LastName: data.lastName,
      DateOfBirth: data.dob,
      Email: data.email,
      Phone: data.phone,
      ZipCode: data.zip,
      PreferredContactMethod: data.preferredContactMethod,
    };

    axios
      .post(
        `${apiUrl}/${context.state.diseaseFund.fundId}/supportprograms/refer`,
        requestBody
      )
      .then((_) => {
        setSubmitted(true);
      })
      .catch((_) => {
        context.actions.renderError();
      });
  };

  return (
    <Fragment>
      {context.state.supportPrograms.map((service, i) => (
        <div key={i}>
          <p className="f-h5 c-purple u-mb1">Get free support services from {service.Name}{" "}</p>
          <p>{service.Name} can offer education and support services. Click 'contact me' to sign up.</p>

          <div class="u-form u-mt1" key={i}>
            <input
              value={service.Id}
              name={`supportServiceIds[${i}]`}
              id={`support-service-${i}`}
              type="checkbox"
              onChange={(e) => {
                const value = e.target.value;
                const checked = e.target.checked;

                dispatchSupportServiceIds({
                  type: checked ? "add" : "remove",
                  value: value,
                });
              }}
            />
            <label htmlFor={`support-service-${i}`}>CONTACT ME</label>
          </div>
        </div>
      ))}

      {submitted && (
        <Fragment>
          <p className="f-h5 c-purple u-mb1">Thank you!</p>
          <p>
            We will send your information to our partner organization.
            They will follow up with you soon through your preferred contact method.
          </p>
        </Fragment>
      )}

      {!submitted && (
        <form
          onSubmit={handleSubmit(subscribe)}
          className="u-form"
          id="ga-educationSupportServicesForm"
        >
          {supportServiceIds.length > 0 && (
            <Fragment>
              <div className="u-mb4 u-mt4">
                <label htmlFor="firstName">
                  First Name*
                  {errors.firstName && errors.firstName.type === "required" && (
                    <span data-validate="error">
                      Please provide your first name.
                    </span>
                  )}
                  {errors.firstName &&
                    errors.firstName.type === "maxLength" && (
                      <span data-validate="error">
                        Can only be a maximum of 50 characters
                      </span>
                    )}
                  {errors.firstName && errors.firstName.type === "pattern" && (
                    <span data-validate="error">
                      Please provide a valid name.
                    </span>
                  )}
                </label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  maxLength="50"
                  ref={register({
                    required: true,
                    maxLength: 50,
                    pattern: nameRegex,
                  })}
                  placeholder="Enter First Name"
                />
              </div>

              <div className="u-mb4">
                <label htmlFor="middleName">
                  Middle Name
                  {errors.middleName &&
                    errors.middleName.type === "maxLength" && (
                      <span data-validate="error">
                        Can only be a maximum of 50 characters
                      </span>
                    )}
                  {errors.middleName &&
                    errors.middleName.type === "pattern" && (
                      <span data-validate="error">
                        Please provide a valid name.
                      </span>
                    )}
                </label>
                <input
                  type="text"
                  id="middleName"
                  name="middleName"
                  placeholder="Enter Middle Name"
                  maxLength="50"
                  ref={register({
                    maxLength: 50,
                    pattern: nameRegex,
                  })}
                />
              </div>

              <div className="u-mb4">
                <label htmlFor="lastName">
                  Last Name*
                  {errors.lastName && errors.lastName.type === "required" && (
                    <span data-validate="error">
                      Please provide your last name.
                    </span>
                  )}
                </label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  maxLength="50"
                  ref={register({
                    required: true,
                    maxLength: 50,
                    pattern: nameRegex,
                  })}
                  placeholder="Enter Last Name"
                />
                {errors.lastName && errors.lastName.type === "required" && (
                  <p>Please provide your last name.</p>
                )}
              </div>

              <div className="u-mb4">
                <label htmlFor="dob">
                  Date of birth*
                  {errors.dob && errors.dob.type === "required" && (
                    <span data-validate="error">
                      Please provide your date of birth.
                    </span>
                  )}
                  {errors.dob && errors.dob.type === "pattern" && (
                    <span data-validate="error">
                      Please provide a valid date. Must be formatted as MM/DD/YYYY.
                    </span>
                  )}
                </label>
                <input
                  type="text"
                  id="dob"
                  name="dob"
                  placeholder="MM/DD/YYYY"
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.match(/^\d{2}$/) !== null) {
                      e.target.value = value + "/";
                    } else if (value.match(/^\d{2}\/\d{2}$/) !== null) {
                      e.target.value = value + "/";
                    }
                  }}
                  ref={register({ required: true, pattern: dateRegex })}
                />
              </div>

              <div className="u-mb4">
                <label htmlFor="email">
                  Email*
                  {errors.email && errors.email.type === "required" && (
                    <span data-validate="error">
                      Please provide an email address.
                    </span>
                  )}
                  {errors.email && errors.email.type === "pattern" && (
                    <span data-validate="error">
                      Please provide a valid email address
                    </span>
                  )}
                  {errors.email && errors.email.type === "maxLength" && (
                    <span data-validate="error">
                      Must be less than or equal to 100 characters.
                    </span>
                  )}
                </label>
                <input
                  type="text"
                  inputMode="email"
                  id="email"
                  name="email"
                  maxLength="100"
                  placeholder="Enter Email Address"
                  ref={register({
                    required: true,
                    pattern: emailRegex,
                    maxLength: 100,
                  })}
                />
              </div>

              <div className="u-mb4">
                <label htmlFor="phone">
                  Phone*
                  {errors.phone && errors.phone.type === "required" && (
                    <span data-validate="error">Please provide your phone number.</span>
                  )}
                  {errors.phone && errors.phone.type === "pattern" && (
                    <span data-validate="error">Must be a 10 digit phone number. Do not include spaces, parenthesis, or dashes.</span>
                  )}
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  inputMode="numeric"
                  maxLength="10"
                  placeholder="Enter Phone Number"
                  ref={register({ required: true, pattern: phoneRegex })}
                />
              </div>

              <div className="u-mb4">
                <label htmlFor="zip">
                  ZIP Code
                  {errors.zip && errors.zip.type === "pattern" && (
                    <span data-validate="error">Must be a 5-digit ZIP Code</span>
                  )}
                </label>
                <input
                  type="text"
                  id="zip"
                  name="zip"
                  placeholder="5-digit ZIP"
                  maxLength="5"
                  ref={register({ pattern: zipRegex })}
                />
              </div>

              <fieldset className="u-mb4">
                <legend className="c-purple f-lumaSansBold u-mb1-em">
                  Preferred contact method
                </legend>

                <div className="u-mb1-em">
                  <input
                    id="contactEmail"
                    type="radio"
                    name="preferredContactMethod"
                    value="Email"
                    ref={register}
                  />
                  <label htmlFor="contactEmail">Email</label>
                </div>

                <div>
                  <input
                    id="contactPhone"
                    type="radio"
                    name="preferredContactMethod"
                    value="Phone"
                    ref={register}
                  />
                  <label htmlFor="contactPhone">Phone</label>
                </div>
              </fieldset>

              <button disabled={submitting} className="btn" type="submit">
                {submitting ? "Submitting..." : "Submit"}
              </button>
            </Fragment>
          )}
        </form>
      )}
    </Fragment>
  );
};

export default Email;
